import { useCookies } from "react-cookie";
import { Route, Routes } from "react-router-dom";
import { AdminInfluencer } from "./AdminInfluencer";
import { AdminDeals } from "./AdminDeals";
import { AdminAddDeals } from "./AdminAddDeals";
import { AdminInfluencerCollabs } from "./AdminInfluencerCollabs";
import { AdminCollabEarning } from "./AdminCollabEarning";
import AdminBrandInvoicePage from "./AdminBrandInvoices";
import { SidebarInset, SidebarProvider } from "@/shadcnComponents/ui/sidebar";
import { DeveloperSidebar } from "../DeveloperComponents/DeveloperSidebar";
import AdminAllCampaignsPage from "./AdminAllCampaigns";
import AdminCampaignReviewPage from "./AdminCampaignReview";
import AdminCreatorInvoicePage from "./AdminCreatorInvoice";
import { DeveloperEmailCampaignDashboard } from "./AdminEmailCampaigns";

const jwtTokenDeveloper = import.meta.env.VITE_JwtTokenDeveloper;

export const AdminDashBoard = () => {
  const [cookies, , removeCookie] = useCookies();

  const handleLogout = () => {
    localStorage.removeItem("jwtTokenD");
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("isUser");
    localStorage.removeItem("isDev");
    localStorage.removeItem("c_id");
    removeCookie("devsession");
  };

  if (
    localStorage.getItem("jwtTokenD") !== jwtTokenDeveloper ||
    !localStorage.getItem("isDev") ||
    !cookies.devsession
  ) {
    handleLogout();
    window.open("/developer/login", "_self");
  }
  return (
    <>
      <SidebarProvider>
        <DeveloperSidebar />
        <SidebarInset className="max-w-[1256px]">
          <div className="w-full h-full gap-[20px]">
            <div className=" w-full flex flex-col  items-center justify-center gap-[20px] ">
              <Routes>
                <Route
                  path="*"
                  element={<AdminInfluencer userType={"Influencer"} />}
                />
                <Route
                  path="/brands"
                  element={<AdminInfluencer userType={"Brand"} />}
                />
                <Route
                  path="/deals"
                  element={<AdminDeals handleLogout={handleLogout} />}
                />
                <Route path="/deals/add" element={<AdminAddDeals />} />
                <Route
                  path="/pastCollabs/:id"
                  element={<AdminInfluencerCollabs />}
                />
                <Route
                  path="/collab-earning"
                  element={<AdminCollabEarning />}
                />
                <Route
                  path="/brand-invoice"
                  element={<AdminBrandInvoicePage />}
                />
                <Route
                  path="/creator-invoice"
                  element={<AdminCreatorInvoicePage />}
                />
                <Route
                  path="/allCampaigns"
                  element={<AdminAllCampaignsPage />}
                />
                <Route
                  path="/campaign/:id"
                  element={<AdminCampaignReviewPage />}
                />
                <Route
                  path="/email-campaigns"
                  element={<DeveloperEmailCampaignDashboard />}
                />
              </Routes>
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </>
  );
};
